(function() {
    'use strict';

    angular.module('settings')
        .controller('BannerListController', BannerListController);

    BannerListController.$inject = ['$state', 'bannerDataSrvc', 'bannerSrvc', 'notificationSrvc', 'bannerMessagesConst', 'lodashService', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'bannerPermissionsConst', 'searchFilterSrvc', 'filterQuerySrvc'];

    function BannerListController($state, bannerDataSrvc, bannerSrvc, notificationSrvc, bannerMessagesConst, lodashService, datatableDefaultPageSizeValueConst, checkSearchSrvc, bannerPermissionsConst, searchFilterSrvc, filterQuerySrvc) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.logsInfo = [{
            title: 'Data dodania',
            value: 'date_added'
        }, {
            title: 'Data modyfikacji',
            value: 'date_modified'
        }, {
            title: 'Edytowano przez',
            value: 'last_modified_by'
        }];

        self.bannerRows = [];
        self.bannerCols = [{
            title: 'Obrazek',
            value: 'image',
            type: 'image'
        }, {
            title: 'Nazwa',
            value: 'name',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Strony',
            value: 'pages',
            type: 'text'
        }, {
            title: 'Url',
            value: 'url',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Opublikowany',
            value: 'is_published',
            type: 'boolean',
            searchable: true,
            orderable: true
        }, {
            title: 'Czas emisji od',
            value: 'datetime_from',
            type: 'datetime',
            searchable: true,
            orderable: true
        }, {
            title: 'Czas emisji do',
            value: 'datetime_to',
            type: 'datetime',
            searchable: true,
            orderable: true
        }, {
            title: 'Dostępne w sklepie',
            value: 'available_in_countries',
            type: 'text',
            searchable: true,
            orderable: true
        }];

        self.modelPermissions = bannerPermissionsConst;
        self.searchQuery = {
            name: null,
            url: null,
            is_published: null,
            datetime_from: null,
            datetime_to: null,
            available_in_countries: null,
            ordering: null
        };

        self.onCreate = onCreate;
        self.onEdit = onEdit;
        self.onDelete = onDelete;
        self.onReorder = onReorder;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getBanner();
        }

        function getBanner(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    name: self.searchQuery.name || undefined,
                    url: self.searchQuery.url || undefined,
                    is_published: self.searchQuery.is_published || undefined,
                    datetime_from: searchFilterSrvc.getDatetimeValue(self.searchQuery.datetime_from),
                    datetime_to: searchFilterSrvc.getDatetimeValue(self.searchQuery.datetime_to),
                    available_in_countries: self.searchQuery.available_in_countries || undefined,
                    ordering: self.searchQuery.ordering
                };
            }
            return bannerDataSrvc.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.bannerRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getBanner);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function onCreate() {
            $state.go('layout.banner.create');
        }

        function onEdit(row) {
            $state.go('layout.banner.update', { pk: row.pk });
        }

        function onDelete(row) {
            return bannerSrvc.remove(row.name, row.pk,
                function(response) {
                    notificationSrvc.notification("success", bannerMessagesConst.delete);
                    lodashService.remove(self.bannerRows, { pk: row.pk });
                    return response;
                },
                function(error) {
                    notificationSrvc.notification("error", error.data.detail);
                });
        }

        function onReorder(row, newPos) {
            return bannerDataSrvc.update({
                pk: row.pk
            }, {
                position: newPos
            });
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getBanner();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getBanner();
        }
    }
})();
